































































































import ThreeColumns from '@/components/NEW-STRUCTURE/desktop/Admin/layout/ThreeColumns.vue';
import SuccessModal from '@/components/NEW-STRUCTURE/desktop/Admin/modals/SuccessModal.vue';
import ChannelList from '@/views/Admin/Channels/ChannelList/ChannelList.vue';
import { defineComponent, Ref, ref, onMounted, watch, onBeforeUnmount, ComputedRef, computed } from '@vue/composition-api';
import PanelTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/PanelTitle.vue';
import AddButton from '@/components/NEW-STRUCTURE/desktop/Admin/buttons/AddButton.vue';

// store
import { Actions, Mutations } from '@/ts/store/modules/Channels/constants';
import { Actions as LegacyActions, Endpoints } from '@/ts/store/Constants';
import ChannelListData from '@/ts/Channels/ChannelListData';
import ProjectsData from '@/ts/ProjectsData';


import axios from 'axios';

import ChannelBlockedMembers from '@/views/Admin/Channels/ChannelBlockedMembers/ChannelBlockedMembers.vue';
import ChannelCreateModal from '@/views/Admin/Channels/ChannelCreate/ChannelCreate.vue';
import ChannelEdit from '@/views/Admin/Channels/ChannelEdit/ChannelEdit.vue';
import ChannelFeed from '@/views/Admin/Channels/ChannelFeed/ChannelFeed.vue';
import ChannelInfo from '@/views/Admin/Channels/components/ChannelInfo.vue';
import ChannelInviteMembers from '@/views/Admin/Channels/ChannelInviteMembers/ChannelInviteMembers.vue';
import ChannelManagementOptions from '@/views/Admin/Channels/ChannelManagementOptions/ChannelManagementOptions.vue';
import ChannelMemberList from '@/views/Admin/Channels/ChannelMembers/ChannelMemberList.vue';
import ChannelModeration from '@/views/Admin/Channels/ChannelModeration/ChannelModeration.vue';
import PrivateChannelPlaceholder from '@/views/Admin/Channels/components/PrivateChannelPlaceholder.vue';
import SelectChannelPlaceholder from '@/views/Admin/Channels/components/SelectChannelPlaceholder.vue';

export default defineComponent({
components: {
        AddButton,
        ChannelBlockedMembers,
        ChannelCreateModal,
        ChannelEdit,
        ChannelFeed,
        ChannelInfo,
        ChannelList,
        ChannelInviteMembers,
        ChannelManagementOptions,
        ChannelMemberList,
        ChannelModeration,
        PanelTitle,
        PrivateChannelPlaceholder,
        SelectChannelPlaceholder,
        SuccessModal,
        ThreeColumns,
    },
setup (props, { emit, root }) {
    
    const store = root.$store;

    const selectedChannel: Ref<any> = ref(null); 

    const showModal: Ref<boolean> = ref(false); 

    const showInviteMembersModal: Ref<boolean> = ref(false); 

    const projects: Ref<ProjectsData[]> = ref(null);

    const project: Ref<ProjectsData> = ref(null);

    const channelTabs: ComputedRef<any> = computed(() => {
        return store.getters['Channels/getChannelsTabs'];
    });

    const channelManagementTab: Ref<string> = ref(channelTabs.value.CHANNEL_INFO);

    const showSuccessModal: Ref<boolean> = ref(false);

    const handleProjectSelect = (event) => {
        selectedChannel.value = null;
        const projectId = event ? event.target.value : null;
        project.value = projectId;
    };

    const changeManagementTab = (newTab: string) => {
        channelManagementTab.value = newTab;
    };
    
    const handleChannelSelect = channel => {
        selectedChannel.value = channel;
        const { CHANNEL_INFO } = channelTabs.value;
        channelManagementTab.value = CHANNEL_INFO;
    }

    const handleEditedChannel = (editedChannel: ChannelListData) => {
        if (editedChannel && editedChannel.id) {
            store.commit(Mutations.UPDATE_CHANNEL_DATA, editedChannel);
        }
    }

    const onShowSuccessModal = (editedChannel: ChannelListData) => {
        showSuccessModal.value = true;
    }

    const fetchProjects = () => {
        axios.get(Endpoints.Admin.Projects.PROJECTS).then((response) => {
            projects.value = response.data;
        });
    }

    onMounted(() => {
        fetchProjects();
    });

    onBeforeUnmount(() => {
        project.value = null;
        selectedChannel.value = null;
        projects.value = null;
    });

    watch(() => projects.value, (currentValue, oldValue) => {
        if (currentValue.length) {
            //@ts-ignore
            project.value =  currentValue[0].id;
        }
    });

    watch(() => project.value, (currentValue, oldValue) => {
        store.dispatch(Actions.FETCH_PPROJECT_CHANNEL_LIST, currentValue);
    });

    return {
        channelManagementTab,
        changeManagementTab,
        handleChannelSelect,
        handleEditedChannel,
        handleProjectSelect,
        selectedChannel,
        onShowSuccessModal,
        projects,
        project,
        showInviteMembersModal,
        showSuccessModal,
        showModal,
        channelTabs,
    }
}
});
